import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, unref as _unref, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/logo1.png';
import _imports_1 from '@/assets/xingl/e17d038d1fb9afac555408a6da02235.png';
import _imports_2 from '@/assets/xingl/Medal.png';
import _imports_3 from '@/assets/xingl/stickynotes.png';
const _withScopeId = n => (_pushScopeId("data-v-2eb0b37a"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "container_2"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "container_2_1"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {
    "height": "70px"
  },
  alt: ""
}), /*#__PURE__*/_createTextVNode(" ·kids 全球分级阅读 ")])], -1));
const _hoisted_2 = {
  style: {
    "width": "100vw",
    "height": "100vh",
    "overflow-y": "auto",
    "display": "flex",
    "flex-direction": "column",
    "align-items": "center"
  }
};
const _hoisted_3 = {
  class: "container"
};
const _hoisted_4 = {
  class: "container_1"
};
const _hoisted_5 = {
  class: "headerdsadas"
};
const _hoisted_6 = {
  style: {
    "display": "flex",
    "justify-content": "flex-start",
    "flex-wrap": "wrap",
    "width": "100%"
  }
};
const _hoisted_7 = ["onClick"];
const _hoisted_8 = {
  style: {
    "display": "flex",
    "justify-content": "space-between",
    "width": "100%"
  }
};
const _hoisted_9 = ["onClick"];
const _hoisted_10 = ["onClick"];
const _hoisted_11 = {
  class: "card-wrapper"
};
const _hoisted_12 = {
  key: 0,
  class: "asd"
};
const _hoisted_13 = ["onClick"];
const _hoisted_14 = ["alt"];
const _hoisted_15 = {
  class: "card-content"
};
const _hoisted_16 = {
  class: "ddddate"
};
const _hoisted_17 = {
  style: {
    "padding": "5px",
    "margin": "5px 10px",
    "margin-left": "0",
    "background": "#4f24ff",
    "border-radius": "2px",
    "font-size": "0.7rem",
    "color": "#ffffff"
  }
};
const _hoisted_18 = {
  style: {
    "font-size": "1rem",
    "margin": "0 5px"
  }
};
const _hoisted_19 = {
  style: {
    "padding": "5px",
    "margin": "5px",
    "margin-left": "0",
    "background": "#4f24ff",
    "border-radius": "2px",
    "font-size": "0.7rem",
    "color": "#ffffff"
  }
};
const _hoisted_20 = {
  style: {
    "font-size": "1rem",
    "margin": "0 5px"
  }
};
const _hoisted_21 = {
  style: {
    "padding": "5px",
    "margin": "5px",
    "margin-left": "0",
    "border-radius": "2px",
    "background": "#4f24ff",
    "font-size": "0.7rem",
    "color": "#ffffff"
  }
};
const _hoisted_22 = {
  style: {
    "font-size": "1rem",
    "margin": "0 5px"
  }
};
const _hoisted_23 = {
  style: {
    "padding": "5px",
    "margin": "5px",
    "margin-left": "0",
    "background": "#4f24ff",
    "font-size": "0.7rem",
    "border-radius": "2px",
    "color": "#ffffff"
  }
};
const _hoisted_24 = {
  style: {
    "font-size": "1rem",
    "margin": "0 5px"
  }
};
const _hoisted_25 = {
  style: {
    "padding": "5px",
    "margin": "5px",
    "margin-left": "0",
    "background": "#4f24ff",
    "font-size": "0.7rem",
    "border-radius": "2px",
    "color": "#ffffff"
  }
};
const _hoisted_26 = {
  style: {
    "font-size": "1rem",
    "margin": "0 5px"
  }
};
const _hoisted_27 = {
  style: {
    "padding": "5px",
    "margin": "5px",
    "margin-left": "0",
    "background": "#4f24ff",
    "font-size": "0.7rem",
    "border-radius": "2px",
    "color": "#ffffff"
  }
};
const _hoisted_28 = {
  style: {
    "font-size": "1rem",
    "margin": "0 5px"
  }
};
const _hoisted_29 = {
  class: "date"
};
const _hoisted_30 = {
  style: {
    "margin": "0.5rem",
    "padding": "0.2rem 0.5rem",
    "border-radius": "2px",
    "background": "#4f24ff",
    "font-size": "1rem",
    "color": "#ffffff"
  }
};
const _hoisted_31 = {
  class: "description"
};
const _hoisted_32 = {
  style: {
    "display": "flex",
    "justify-content": "center",
    "align-items": "center",
    "max-width": "1200px",
    "width": "95vw",
    "flex-direction": "column"
  }
};
const _hoisted_33 = {
  key: 0,
  src: _imports_1,
  alt: "Rotating Image",
  class: "rotating-image"
};
const _hoisted_34 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: /*#__PURE__*/_normalizeClass(['circle-button', 'active'])
}, " X ", -1));
const _hoisted_35 = [_hoisted_34];
const _hoisted_36 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M512 64C264.8 64 64 264.8 64 512s200.8 448 448 448 448-200.8 448-448S759.2 64 512 64z m238.4 641.6l-45.6 45.6L512 557.6 318.4 750.4l-45.6-45.6L467.2 512 273.6 318.4l45.6-45.6L512 467.2l193.6-193.6 45.6 45.6L557.6 512l192.8 193.6z",
  "p-id": "16266",
  fill: "#ffffff"
}, null, -1));
const _hoisted_37 = [_hoisted_36];
const _hoisted_38 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://app.smartschool.chat/img/ccxx/gszt1/_20251219160032_1918_63.jpg",
  alt: "",
  style: {
    "width": "100%",
    "height": "100%",
    "border-radius": "16px",
    "position": "relative",
    "top": "3px"
  }
}, null, -1));
const _hoisted_39 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "",
  style: {
    "max-height": "2rem",
    "position": "relative",
    "margin-right": "0.3rem"
  }
}, null, -1));
const _hoisted_40 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: "",
  style: {
    "max-height": "2rem",
    "position": "relative",
    "margin-right": "0.3rem"
  }
}, null, -1));
import { onMounted, ref, onUnmounted, onBeforeUnmount, watch } from "vue";
import { useRouter } from "vue-router";
import { magazine, smagazineeagetrch, smagazineasjkdch } from "@/api/python.js";
import { musidddaa, approvegradedpost } from "@/api/indd";
import { useRoute } from "vue-router";
import { log } from "vexflow";
import Payment from "@/components/Payment copy.vue";

import { ElMessage } from 'element-plus/es';
import 'element-plus/es/components/base/style/css';
import 'element-plus/es/components/message/style/css';
export default {
  __name: 'index',
  setup(__props) {
    const input1 = ref("");
    const select = ref(1);
    const total_pages = ref(1);
    const centerDireTools = ref(false);

    // 处理页码变化的函数
    const handlePageChange = page => {
      pageSize.value = page;
      cards.value = [];
      console.log(fjk.value);
      if (fjk.value == 1) {
        jkdhaskblf();
      }
      if (fjk.value == 2) {
        sssjlm();
      }
      if (fjk.value == 3) {
        flsjkasldd();
      }

      // console.log('当前选中的页码:', page)
    };
    const route = useRoute();
    const router = useRouter();
    const buttons = [
    // {
    //     label: "全部",
    //     subItems: [
    //       "BR-450",
    //       "451-550",
    //       "501-600",
    //       "551-650",
    //       "651-770",
    //       "771-830",
    //       "831-980",
    //     ],
    //   }, 
    {
      label: "Lexile (蓝思指数)",
      subItems: ["BR-450", "451-550", "551-650", "651-770", "771-830", "831-980"]
    }, {
      label: "阅读AR值 (Reading AR Value)",
      subItems: ["0-1.0", "1.1-2.0", "2.1-3.0", "3.1-4.0", "4.1-5.0", "5.1-6.0"]
    }, {
      label: "单词数量",
      subItems: ["0-100", "101-200", "201-300", "301-400", "401-500", "501-600", "601-700", "701-800", "801-900", "901-1000"]
    }, {
      label: "CEFR等级推荐",
      subItems: ["A1-A2", "B1-B2", "C1-C2"]
    }, {
      label: "RAZ分级推荐",
      subItems: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"]
    }, {
      label: "牛津树分级推荐",
      subItems: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16"]
    }];
    const options = ['All', "Science", "Community", "Health", "Animals", "World", "Business", "Technology", "Environment", "United States", "Sports", "Arts", "TFK Press Club", "Holidays", "History", "Entertainment", "Opinion", "Media Literacy", "Election 2024", "Culture", "Books", "Movies and Television", "Space", "The View", "Text Sets", "Time Off", "Service Stars", "Young Game Changers", "Debate", "Weather", "Transportation", "Election 2020"];
    const selectedValue = ref('All');
    const selectedValuezzzz = ref(0);

    // watch(selectedValue, (newValue) => {
    //   console.log('Selected value:', newValue);
    //   jkdhaskblf()
    // });
    const cards = ref([]);
    const fjk = ref(1);
    const activeButton = ref(0);
    const activeButtonddd = ref(0);
    const isr = ref();
    const subMenuVisible = ref(true);
    //搜索
    let timer = null;
    const dsadasfffas = (() => {
      let isRunning = false;
      return () => {
        if (isRunning) return;
        isRunning = true;
        if (timer) {
          clearTimeout(timer);
        }
        timer = setTimeout(() => {
          if (input1.value) {
            pageSize.value = 1;
            // asdasd.value = "";
            cards.value = [];
            console.log(input1.value);
            hjasdh.value = true;
            console.log('activeButton.value', activeButton.value);
            if (activeButton.value) {
              var params = {
                0: "Lexile",
                1: "AR",
                2: "Word_num",
                3: "CEFR",
                4: "RAZ",
                5: "njs"
              };
              if (select.value == 1) {
                var data = {
                  title: input1.value,
                  content: null,
                  isr: 1,
                  page: pageSize.value,
                  [params[activeButton.value]]: asdasd.value,
                  labe: selectedValue.value
                };
              } else {
                var data = {
                  title: null,
                  content: input1.value,
                  isr: 2,
                  page: pageSize.value,
                  [params[activeButton.value]]: asdasd.value,
                  labe: selectedValue.value
                };
              }
            } else {
              if (select.value == 1) {
                var data = {
                  title: input1.value,
                  content: null,
                  isr: 1,
                  page: pageSize.value,
                  labe: selectedValue.value
                };
              } else {
                var data = {
                  title: null,
                  content: input1.value,
                  isr: 2,
                  page: pageSize.value,
                  labe: selectedValue.value
                };
              }
            }
            smagazineeagetrch(data).then(res => {
              jsdk.value = 0;
              fjk.value = 2;
              hjasdh.value = false;
              isr.value = res.isr;
              cards.value = res.data;
              total_pages.value = res.total_pages; //总页数
            });
          } else {
            ElMessage.error("请输入内容.");
          }
          isRunning = false;
        }, 500);
      };
    })();
    const showSubMenu = index => {
      activeButton.value = index;
      activeButtonddd.value = index;
      subMenuVisible.value = true;
      asldkj.value = false;
    };
    const dsaddasf = (index, button) => {
      selectedValuezzzz.value = index;
      selectedValue.value = button;
      handlePageChange();
    };
    const asldkj = ref(true);
    const asdasd = ref("");
    const hideSubMenu = () => {
      // activeButtonddd.value = null;
      // subMenuVisible.value = false;
    };
    const handleCardClick = a => {
      approvegradedpost().then(res => {
        if (res.content == -1) {
          centerDireTools.value = true;
          return;
        } else {
          localStorage.setItem("articdsadfle", JSON.stringify(a));
          localStorage.setItem("asdasd1", asdasd.value);
          localStorage.setItem("cards1", JSON.stringify(cards.value));
          localStorage.setItem("total_pages1", total_pages.value);
          localStorage.setItem("pageSize1", pageSize.value);
          localStorage.setItem("input11", input1.value);
          localStorage.setItem("select1", select.value);
          localStorage.setItem("fjk1", fjk.value);
          localStorage.setItem("activeButton1", activeButton.value);
          localStorage.setItem("activeButtonddd1", activeButtonddd.value);
          localStorage.setItem("isr1", isr.value);
          localStorage.setItem("selectedValue1", selectedValue.value);
          localStorage.setItem("selectedValuezzzz1", selectedValuezzzz.value);

          // console.log(asdasd.value);
          // console.log(cards.value);
          // console.log(total_pages.value);
          // console.log(pageSize.value);
          // console.log( input1.value);
          // console.log(select.value);

          router.push({
            name: "artical" //可以改成name
          });
        }
      });
    };
    //分类
    let timerd = null;
    const handleSubMenuClick = (() => {
      let isRunning = false;
      return subItem => {
        if (isRunning) return;
        isRunning = true;
        if (timerd) {
          clearTimeout(timerd);
        }
        timerd = setTimeout(() => {
          jsdk.value = 0;
          input1.value = "";
          asdasd.value = subItem;
          pageSize.value = 1;
          cards.value = [];
          hjasdh.value = true;
          console.log(activeButton.value);
          const params = {
            0: "Lexile",
            1: "AR",
            2: "Word_num",
            3: "CEFR",
            4: "RAZ",
            5: "njs"
          };
          var data = {
            [params[activeButton.value]]: subItem,
            page: pageSize.value,
            labe: selectedValue.value
          };
          smagazineasjkdch(data).then(res => {
            fjk.value = 3;
            hjasdh.value = false;
            cards.value = res.data;
            total_pages.value = res.total_pages; //总页数
          });
          isRunning = false;
        }, 500);
      };
    })();
    const handleClickOutside = event => {
      if (!event.target.closest(".header")) {
        hideSubMenu();
      }
      if (!event.target.closest(".dropdown-select")) {
        ashjkfsafa.value = true;
      }
      asldkj.value = true;
    };
    const grow_up = ref();
    const ashjkfsafa = ref(true);
    const djklas = () => {
      ashjkfsafa.value = !ashjkfsafa.value;
      console.log('dasd');
    };
    onMounted(() => {
      let cards1 = localStorage.getItem("cards1");
      let total_pages1 = localStorage.getItem("total_pages1");
      let asdasd1 = localStorage.getItem("asdasd1");
      let pageSize1 = localStorage.getItem("pageSize1");
      let input11 = localStorage.getItem("input11");
      let select1 = localStorage.getItem("select1");
      let fjk1 = localStorage.getItem("fjk1");
      let activeButton1 = localStorage.getItem("activeButton1");
      let isr1 = localStorage.getItem("isr1");
      let selectedValue1 = localStorage.getItem("selectedValue1");
      let activeButtonddd1 = localStorage.getItem("activeButtonddd1");
      let selectedValuezzzz1 = localStorage.getItem("selectedValuezzzz1");
      if (cards1) {
        console.log('dasdasd');
        cards.value = JSON.parse(cards1);
        total_pages.value = Number(total_pages1);
        asdasd.value = asdasd1;
        pageSize.value = Number(pageSize1);
        select.value = Number(select1);
        input1.value = input11;
        fjk.value = Number(fjk1);
        activeButton.value = Number(activeButton1);
        console.log();
        if (activeButtonddd1 == 'null') {
          activeButtonddd.value = 0;
        } else {
          activeButtonddd.value = Number(activeButtonddd1);
        }
        isr.value = Number(isr1);
        selectedValuezzzz.value = Number(selectedValuezzzz1);
        selectedValue.value = String(selectedValue1);
        localStorage.setItem("asdasd1", '');
        localStorage.setItem("cards1", '');
        localStorage.setItem("total_pages1", '');
        localStorage.setItem("pageSize1", '');
        localStorage.setItem("input11", '');
        localStorage.setItem("select1", '');
        localStorage.setItem("fjk1", '');
        localStorage.setItem("activeButton1", '');
        localStorage.setItem("isr1", '');
        localStorage.setItem("selectedValue1", '');
      } else {
        jkdhaskblf();
      }
      liasdjn();
      musidddaa().then(res => {
        grow_up.value = res.message.grow_up;

        // if (grow_up.value == 4) {
        //   jiaged.value = true;
        //   showPaymentComponent.value = true;
        // }

        localStorage.setItem("date_time", res.message.date_time);
        localStorage.setItem("vip", res.message.vip_time);
        localStorage.setItem("grow_up", res.message.grow_up);
      });
    });
    const pageSize = ref(1);
    // const loadedPages = ref(30);
    //基础数据
    const jkdhaskblf = () => {
      hjasdh.value = true;
      let data = {
        page: pageSize.value,
        labe: selectedValue.value
      };
      magazine(data).then(res => {
        hjasdh.value = false;
        cards.value = res.data;
        total_pages.value = res.total_pages; //总页数
      });
    };
    //搜索数据
    const sssjlm = () => {
      hjasdh.value = true;
      if (isr.value == 1) {
        var data = {
          title: input1.value,
          content: null,
          isr: 1,
          page: pageSize.value,
          labe: selectedValue.value
        };
      } else {
        var data = {
          title: null,
          content: input1.value,
          isr: 2,
          page: pageSize.value,
          labe: selectedValue.value
        };
      }
      smagazineeagetrch(data).then(res => {
        hjasdh.value = false;
        cards.value = res.data;
        total_pages.value = res.total_pages; //总页数
      });
    };

    //分类数据
    const flsjkasldd = () => {
      hjasdh.value = true;
      console.log(activeButton.value);
      if (activeButton.value == 0) {
        var data = {
          Lexile: asdasd.value,
          page: pageSize.value,
          labe: selectedValue.value
        };
      }
      if (activeButton.value == 1) {
        var data = {
          AR: asdasd.value,
          page: pageSize.value,
          labe: selectedValue.value
        };
      }
      if (activeButton.value == 2) {
        var data = {
          Word_num: asdasd.value,
          page: pageSize.value,
          labe: selectedValue.value
        };
      }
      if (activeButton.value == 3) {
        var data = {
          CEFR: asdasd.value,
          page: pageSize.value,
          labe: selectedValue.value
        };
      }
      if (activeButton.value == 4) {
        var data = {
          RAZ: asdasd.value,
          page: pageSize.value,
          labe: selectedValue.value
        };
      }
      if (activeButton.value == 5) {
        var data = {
          njs: asdasd.value,
          page: pageSize.value,
          labe: selectedValue.value
        };
      }
      smagazineasjkdch(data).then(res => {
        hjasdh.value = false;
        cards.value = res.data;
        total_pages.value = res.total_pages; //总页数
      });
    };
    const scrollContainer = ref(null);
    const hjasdh = ref(false);
    const jsdk = ref(0);
    let adsdd;
    const liasdjn = () => {
      adsdd = setInterval(() => {
        musidddaa().then(res => {
          grow_up.value = res.message.grow_up;
          localStorage.setItem("date_time", res.message.date_time);
          localStorage.setItem("vip", res.message.vip_time);
          localStorage.setItem("grow_up", res.message.grow_up);
        });
      }, 600000);
    };
    const componentKeya = ref(0);
    const jiaged = ref(false);
    const showPaymentComponent = ref(false);
    const djashdkkk = () => {
      componentKeya.value += 1;
      jiaged.value = false;
      showPaymentComponent.value = false;
    };
    onBeforeUnmount(() => {
      if (adsdd) {
        clearInterval(adsdd);
        adsdd = null; // 清除timerID值，表示当前没有定时器在运行
        // console.log('定时器已停止');
      } else {
        // console.log('没有运行中的定时器可以停止');
      }
    });
    const dbsfj = () => {
      centerDireTools.value = false;
      jiaged.value = true;
      showPaymentComponent.value = true;
    };
    const asfdasf = () => {
      centerDireTools.value = false;
      showPaymentComponent.value = true;
      router.push({
        path: "./Sharelink"
      });
    };
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_empty = _resolveComponent("el-empty");
      const _component_el_pagination = _resolveComponent("el-pagination");
      const _component_el_dialog = _resolveComponent("el-dialog");
      const _directive_lazy = _resolveDirective("lazy");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", {
        ref_key: "scrollContainer",
        ref: scrollContainer,
        class: "jsdkashf",
        onClick: handleClickOutside
      }, [_hoisted_1, _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(options, (button, index) => {
        return _createElementVNode("button", {
          key: index,
          class: _normalizeClass(["grade-button1111", {
            actidsadve: selectedValuezzzz.value === index
          }]),
          onClick: $event => dsaddasf(index, button)
        }, _toDisplayString(button), 11, _hoisted_7);
      }), 64))])]), _createElementVNode("div", {
        class: "header",
        onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
      }, [_createElementVNode("div", _hoisted_8, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(buttons, (button, index) => {
        return _createElementVNode("button", {
          key: index,
          class: _normalizeClass(["grade-button", {
            active: activeButtonddd.value === index
          }]),
          onClick: $event => showSubMenu(index)
        }, _toDisplayString(button.label), 11, _hoisted_9);
      }), 64))]), subMenuVisible.value ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "sub-menu",
        style: _normalizeStyle({
          'border-top-left-radius': activeButtonddd.value === 0 ? '0' : null,
          'border-top-right-radius': activeButtonddd.value === 5 ? '0' : null
        }),
        onMouseover: _cache[0] || (_cache[0] = $event => subMenuVisible.value = true)
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(buttons[activeButtonddd.value].subItems, (subItem, subIndex) => {
        return _openBlock(), _createElementBlock("button", {
          key: subIndex,
          class: "sub-menu-item",
          style: _normalizeStyle(asdasd.value == subItem ? '  background: #4f24ff; border-radius: 5px; color: #ffffff' : null),
          onClick: $event => _unref(handleSubMenuClick)(subItem)
        }, _toDisplayString(subItem), 13, _hoisted_10);
      }), 128))], 36)) : _createCommentVNode("", true)]), _createVNode(_component_el_input, {
        modelValue: input1.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => input1.value = $event),
        class: "search",
        size: "large",
        placeholder: "Please Input"
      }, {
        prepend: _withCtx(() => [_createVNode(_component_el_select, {
          modelValue: select.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => select.value = $event),
          placeholder: "Select",
          style: {
            "width": "115px"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_option, {
            label: "标题",
            value: 1
          }), _createVNode(_component_el_option, {
            label: "内容",
            value: 2
          })]),
          _: 1
        }, 8, ["modelValue"])]),
        append: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary",
          onClick: _unref(dsadasfffas)
        }, {
          default: _withCtx(() => [_createTextVNode("搜索")]),
          _: 1
        }, 8, ["onClick"])]),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_11, [cards.value.length == 0 && !hjasdh.value ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_createVNode(_component_el_empty, {
        description: "好像没有数据哦，请搜索其他试一试。"
      })])) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cards.value, (card, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: "card",
          key: index,
          onClick: $event => handleCardClick(card)
        }, [_withDirectives(_createElementVNode("img", {
          alt: card.title,
          class: "card-img"
        }, null, 8, _hoisted_14), [[_directive_lazy, card.image]]), _createElementVNode("div", _hoisted_15, [_createElementVNode("p", _hoisted_16, [_createElementVNode("span", _hoisted_17, [_createTextVNode(" AR值:"), _createElementVNode("span", _hoisted_18, _toDisplayString(card.AR), 1)]), _createElementVNode("span", _hoisted_19, [_createTextVNode(" CEFR:"), _createElementVNode("span", _hoisted_20, _toDisplayString(card.CEFR), 1)]), _createElementVNode("span", _hoisted_21, [_createTextVNode(" 蓝思值:"), _createElementVNode("span", _hoisted_22, _toDisplayString(card.Lexile), 1)]), _createElementVNode("span", _hoisted_23, [_createTextVNode(" RAZ:"), _createElementVNode("span", _hoisted_24, _toDisplayString(card.RAZ), 1)]), _createElementVNode("span", _hoisted_25, [_createTextVNode(" 单词量:"), _createElementVNode("span", _hoisted_26, _toDisplayString(card.Word_num), 1)]), _createElementVNode("span", _hoisted_27, [_createTextVNode(" 牛津树:"), _createElementVNode("span", _hoisted_28, _toDisplayString(card.njs), 1)])]), _createElementVNode("h3", null, _toDisplayString(card.title), 1), _createElementVNode("p", _hoisted_29, [_createTextVNode(_toDisplayString(card.insert_date) + " ", 1), _createElementVNode("span", _hoisted_30, _toDisplayString(card.category_label), 1)]), _createElementVNode("p", _hoisted_31, _toDisplayString(card.summary.length > 100 ? card.summary.slice(0, 200) + "..." : card.summary), 1)])], 8, _hoisted_13);
      }), 128))]), _createElementVNode("div", _hoisted_32, [hjasdh.value ? (_openBlock(), _createElementBlock("img", _hoisted_33)) : _createCommentVNode("", true), _createVNode(_component_el_pagination, {
        background: "",
        layout: "prev, pager, next",
        style: {
          "margin-top": "20px",
          "margin-bottom": "20px"
        },
        currentPage: pageSize.value,
        "onUpdate:currentPage": _cache[4] || (_cache[4] = $event => pageSize.value = $event),
        "page-size": 1,
        onCurrentChange: handlePageChange,
        total: total_pages.value
      }, null, 8, ["currentPage", "total"])])])])], 512), _createVNode(_component_el_dialog, {
        modelValue: jiaged.value,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => jiaged.value = $event),
        title: "",
        "show-close": false,
        style: {
          "border-radius": "16px",
          "margin-top": "6vh",
          "width": "90vw",
          "max-width": "1300px",
          "min-height": "430px",
          "min-width": "750px",
          "padding": "0"
        },
        "close-on-click-modal": false
      }, {
        default: _withCtx(() => [_createElementVNode("div", {
          style: {
            "font-weight": "700",
            "position": "absolute",
            "right": "-1rem",
            "top": "-1rem",
            "z-index": "10"
          },
          onClick: djashdkkk
        }, _hoisted_35), showPaymentComponent.value ? (_openBlock(), _createBlock(Payment, {
          key: componentKeya.value
        })) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
        modelValue: centerDireTools.value,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => centerDireTools.value = $event),
        title: "",
        width: "500",
        "before-close": _ctx.ndmsssTools,
        style: {
          "border-radius": "16px",
          "background-color": "#00000000",
          "padding": "0"
        },
        "close-on-click-modal": false
      }, {
        default: _withCtx(() => [(_openBlock(), _createElementBlock("svg", {
          t: "1737710478191",
          class: "icon",
          viewBox: "0 0 1024 1024",
          version: "1.1",
          onClick: _cache[6] || (_cache[6] = $event => centerDireTools.value = false),
          style: {
            "width": "40px",
            "height": "40px",
            "position": "absolute",
            "top": "-1rem",
            "right": "-1rem",
            "z-index": "10"
          },
          xmlns: "http://www.w3.org/2000/svg",
          "p-id": "16265",
          width: "48",
          height: "48"
        }, _hoisted_37)), _hoisted_38, _createVNode(_component_el_button, {
          style: {
            "position": "absolute",
            "bottom": "5rem",
            "right": "9rem",
            "font-size": "20px",
            "height": "2.5rem",
            "box-shadow": "rgb(0 0 0 / 37%) 0px 1px 18px 7px"
          },
          onClick: _cache[7] || (_cache[7] = $event => dbsfj())
        }, {
          default: _withCtx(() => [_hoisted_39, _createTextVNode("付费充值")]),
          _: 1
        }), _createVNode(_component_el_button, {
          style: {
            "position": "absolute",
            "bottom": "1.2rem",
            "right": "9rem",
            "font-size": "20px",
            "height": "2.5rem",
            "box-shadow": "rgb(0 0 0 / 37%) 0px 1px 18px 7px"
          },
          onClick: _cache[8] || (_cache[8] = $event => asfdasf())
        }, {
          default: _withCtx(() => [_hoisted_40, _createTextVNode("购买应急券")]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue", "before-close"])], 64);
    };
  }
};